module.exports = __webpack_public_path__ + "static/media/lauriko.6431ccba.webp";